import React, { useState, useEffect } from "react";
import { useDispatch } from "utils/redux";
import { useParams } from "react-router-dom";

import Table from "components/Table/Table.tsx";
import type { RREImportDataType } from "types/DataTypes";
import {
  useGetRresImporLogsByRreIdQuery,
  useGetRreValidationsQuery,
} from "services/rre-api.ts";
import RREPageContainer from "./RREPageContainer";
import { setIsLoading } from "reducers/main";
import DownloadLink from "components/common/DownloadLink.tsx";
import { setValidationState } from "reducers/main.ts";

const IMPORT_COLUMNS = [
  { key: "import_type_verbose", name: "Import Type" },
  { key: "status_verbose", name: "Import Status" },
  { key: "processing_started_on", name: "Import Time" },
  { key: "import_by_username", name: "Imported By" },
  { key: "antivirus_scan_status_verbose", name: "Virus Scan" },
  { key: "exception_message", name: "Exception Message" },
  {
    key: "actions",
    name: "Actions",
    renderCell(props) {
      return (
        <>
          <DownloadLink
            url={props?.row?.import_document_url}
            icon="download"
            filename={props?.row?.import_document_filename}
            title="Download Import File"
            disabled={props?.row?.import_document_url ? false : true}
          />
          <DownloadLink
            url={props?.row?.rejection_document_url}
            icon="feedback"
            filename={props?.row?.rejection_document_filename}
            title="Download Rejection File"
            disabled={props?.row?.rejection_document_url ? false : true}
          />
        </>
      );
    },
  },
];

const RREImportTablePage = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState<RREImportDataType[]>([]);
  const { rreId } = useParams<{ rreId: string }>();

  const { data: logs, isLoading } = useGetRresImporLogsByRreIdQuery(
    { rreId },
    { skip: !rreId },
  );

  const { data: rreValidation } = useGetRreValidationsQuery(
    { id: rreId },
    { skip: !rreId },
  );

  useEffect(() => {
    if (rreValidation) {
      const validationData = Object.values(rreValidation).flat();
      const errors = validationData.filter((item) => item.level === "ERROR");
      const warnings = validationData.filter((item) => item.level === "WARN");
      dispatch(
        setValidationState({
          errors: errors,
          warnings: warnings,
        }),
      );
    }
  }, [dispatch, rreValidation]);

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  useEffect(() => {
    if (logs) {
      setRows(logs as unknown as RREImportDataType[]);
    }
  }, [logs]);

  return (
    <RREPageContainer>
      <Table
        className="rre-table"
        columns={IMPORT_COLUMNS}
        rows={rows}
        sortColumns={[]}
        rowKeyGetter={(row: RREImportDataType) => {
          return row.id;
        }}
      />
    </RREPageContainer>
  );
};

export default RREImportTablePage;
